var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size md_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("TITLE.APPROVAL.POPUP.TITLE")))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("table", { staticClass: "create_table mt-20" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [
                    _vm._v(
                      "\n                                    " +
                        _vm._s(_vm.$t("FIELD.GLOBAL.SUBJECT")) +
                        "\n                                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                                    " +
                        _vm._s(_vm.detail.KNOWLEDGE_TITLE) +
                        "\n                                "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.SURVEY.TO")))]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", { staticClass: "mr10" }, [
                      _vm._v(_vm._s(_vm.detail.TO_NM))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "mr10" }, [
                      _vm._v(_vm._s(_vm.detail.CORP_NM))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.OPINION")))]),
                  _vm._v(" "),
                  _c("td", [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.approveOpinion,
                          expression: "approveOpinion"
                        }
                      ],
                      staticClass: "text_textarea w100p",
                      attrs: { rows: "4", maxlength: "500" },
                      domProps: { value: _vm.approveOpinion },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.approveOpinion = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_modal_wrap topLine mt-0" }, [
              _c("div", { staticClass: "btn_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_white",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnCancel }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CANCEL")))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn_blue",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnSend }
                  },
                  [
                    _vm._v(
                      "\n                                " +
                        _vm._s(_vm.$t("BUTTON.GLOBAL.SEND")) +
                        "\n                                "
                    ),
                    _c("em", { staticClass: "ico_infoW_btn" }, [
                      _c("i", { staticClass: "tooltip fl_right" }, [
                        _vm._v(
                          "\n                                        " +
                            _vm._s(
                              _vm.$t("MESSAGE.REQUEST.SHARING.SEND.TOOLTIP")
                            ) +
                            "\n                                    "
                        )
                      ])
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "154px" } }),
      _vm._v(" "),
      _c("col", { staticClass: "*" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e9267b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e9267b1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/common/RequestSharingToPopup.vue
// module id = zo82
// module chunks = 0